let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1SjcY")).then(() => parcelRequire('k6ygv'));